import { dropRight, times } from "lodash";
const { useEffect, useState } = wp.element;
import { __ } from "@wordpress/i18n";
import {
  PanelBody,
  RangeControl,
  ToggleControl,
  SelectControl,
  RadioControl,
  __experimentalNumberControl as NumberControl
} from "@wordpress/components";

import {
  InspectorControls,
  useInnerBlocksProps,
  __experimentalBlockVariationPicker,
  useBlockProps,
  InnerBlocks,
  store as blockEditorStore,
} from "@wordpress/block-editor";
import { withDispatch, useSelect, select, subscribe } from "@wordpress/data";

import {
  createBlock,
  createBlocksFromInnerBlocksTemplate,
  store as blocksStore,
} from "@wordpress/blocks";

//import Slider from 'react-slick';

// Import Swiper React components
// import { Swiper, SwiperSlide } from "swiper/react";
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

// Import Swiper styles
// import "swiper/css";
// import "swiper/css/navigation";


// import required modules
import { Navigation } from "swiper";

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";

// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css";
import _uniqueId from 'lodash/uniqueId';
/**
 * Allowed blocks constant is passed to InnerBlocks precisely as specified here.
 * The contents of the array should never change.
 * The array should contain the name of each block that is allowed.
 * In columns block, the only block we allow is 'core/column'.
 *
 * @constant
 * @type {string[]}
 */
const ALLOWED_BLOCKS = ["wp-travel-blocks/slides"];
const TEMPLATE = [["wp-travel-blocks/slides"], ["wp-travel-blocks/slides"]];

function SliderEditContainer({
  attributes,
  setAttributes,
  updateColumns,
  clientId,
}) {

  const {
    slidesPerPage,
    controls,
    autoplay,
    autoplayDelay,
    dot,
    dotPosition,
    axis,
    slideBy,
    center,
  } = attributes;
  const settings = {
    // Optional parameters
      direction: axis,
      loop: true,
      slidesPerView: slidesPerPage,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
    
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
  }
  
  if ( autoplay ) {
    settings['autoplay'] = {
      delay: autoplayDelay,
    }
  }


  const [uniqueId] = useState(_uniqueId('slider-'));
  var [mySwiper, setMySwiper] = useState(null);


  
  const { count } = useSelect(
    (select) => {
      return {
        count: select(blockEditorStore).getBlockCount(clientId),
      };
    },
    [clientId]
    );
    
    useEffect(() => {

      const swiper = new Swiper(`.swiper-${uniqueId}`, settings);
      if ( ! settings.autoplay ) {
        swiper.autoplay.stop()
      }
      mySwiper = swiper;
      
      setMySwiper(swiper);
    }, [slidesPerPage, autoplay, axis]);

  const getBlockList = () => select("core/editor").getBlocks();
  let blockList = getBlockList();
  subscribe(() => {
    const newBlockList = getBlockList();
    const blockListChanged = newBlockList !== blockList;
    blockList = newBlockList;
    if (blockListChanged) {
      const changeEvent = new Event("elementsChanged");
      document.dispatchEvent(changeEvent);
    }
  });
  
  var mainWrapperClassname = `wp-travel-block-slider swiper swiper-${uniqueId}`;
  
  if ( controls ) {
    mainWrapperClassname += ' navigation-enabled';
  }
  
  if ( dot ) {
    mainWrapperClassname += ' pagination-enabled';
  }

  const blockProps = useBlockProps({
    className: mainWrapperClassname,
  });
  
  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    allowedBlocks: ALLOWED_BLOCKS,
    orientation: "horizontal",
    renderAppender: false,
    template: TEMPLATE,
  });

  const showPagination = dot ? 'block' : 'none';

  var sliderWrapperClass = "swiper-wrapper " + "col-" + slidesPerPage
  return (
    <>
      <InspectorControls>
        <PanelBody>
          <RangeControl
            label={__("Number of Slides")}
            value={count}
            onChange={(value) => updateColumns(count, value, mySwiper)}
            min={1}
            max={Math.max(10, count)}
          />
          <RangeControl
            label={__("Number of slides being displayed in the viewport.")}
            help={__(
              "If slides less or equal than items, the slider won't be initialized."
            )}
            value={slidesPerPage}
            onChange={(value) => setAttributes({ slidesPerPage: value }) }
            min={1}
            max={5}
          />
          <ToggleControl
            label={__("Enable controls (Nav Arrows)")}
            checked={controls}
            onChange={() =>
              setAttributes({
                controls: !controls,
              })
            }
          />
          <ToggleControl
            label={__("Enable autoplay")}
            checked={autoplay}
            onChange={() =>
              setAttributes({
                autoplay: !autoplay,
              })
            }
          />
          { autoplay && <NumberControl
            label={__("Autoplay delay")}
            isShiftStepEnabled={ true }
            shiftStep='1000'
            step='1000'
            onChange={(value) =>
              setAttributes({
                autoplayDelay: value,
              })
            }
            value={ autoplayDelay }
          />}
          <ToggleControl
            label={__("Enable dots/pagination")}
            checked={dot}
            onChange={() =>
              setAttributes({
                dot: !dot,
              })
            }
          />
          
        </PanelBody>
      </InspectorControls>
      <div {...blockProps}>
        
        <div className={sliderWrapperClass}>
          { innerBlocksProps.children }
        </div>
        <div className="swiper-pagination" style={{'display': showPagination}}></div>

        { controls && <><div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div></> }
      </div>
    </>
  );
}

const SliderEditContainerWrapper = withDispatch(
  (dispatch, ownProps, registry) => ({
    /**
     * Update all child Column blocks with a new vertical alignment setting
     * based on whatever alignment is passed in. This allows change to parent
     * to overide anything set on a individual column basis.
     *
     * @param {string} verticalAlignment the vertical alignment setting
     */

    /**
     * Updates the column count, including necessary revisions to child Column
     * blocks to grant required or redistribute available space.
     *
     * @param {number} previousColumns Previous column count.
     * @param {number} newColumns      New column count.
     */

    updateColumns(previousColumns, newColumns, swp) {

     
      const { clientId } = ownProps;
      const { replaceInnerBlocks } = dispatch(blockEditorStore);
      const { getBlocks } = registry.select(blockEditorStore);

      let innerBlocks = getBlocks(clientId);

      // Redistribute available width for existing inner blocks.
      const isAddingColumn = newColumns > previousColumns;

      if (isAddingColumn) {
        innerBlocks = [
          ...innerBlocks,
          ...times(newColumns - previousColumns, () => {
            return createBlock("wp-travel-blocks/slides");
          }),
        ];
      } else {
        // The removed column will be the last of the inner blocks.
        innerBlocks = dropRight(innerBlocks, previousColumns - newColumns);
      }
      
      replaceInnerBlocks(clientId, innerBlocks);
      if ( "undefined" !== typeof swp.$el ) {
        swp.update();
      }
    },
  })
)(SliderEditContainer);

const SliderEdit = (props) => {
  const Component = SliderEditContainerWrapper;

  return <Component {...props} />;
};

export default SliderEdit;
